require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 204
// module chunks = 5 6 7 9 10 12 13 14 16 17 18 20 21 22 23 24 25 27